import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import moment from 'moment';

export default class RainbowBadge extends WritingBadge {
  public readonly id = BadgeId.rainbow;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const hour = moment(stats.todaysPage.startedWritingAt)
      .toDate()
      .getHours();
    return hour >= 12 && hour <= 16;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/rainbow.ts